import { createContext, useContext, type ReactNode } from 'react';

type ScreenTopInsetValue = { topInset: number };

const ScreenTopInsetContext = createContext<ScreenTopInsetValue>({ topInset: 0 });

/**
 * Read the top inset reserved by an outer layout (e.g. an onboarding flow
 * with a persistent header overlay). Screen uses this to push its ScrollView
 * content below the layout's header. Defaults to 0 — Screen then falls back
 * to safe-area or to a per-screen header it owns itself.
 */
export function useScreenTopInset() {
  return useContext(ScreenTopInsetContext);
}

type ProviderProps = { topInset: number; children: ReactNode };

/**
 * Wraps a subtree so any nested Screen reserves `topInset` pixels of
 * paddingTop on its ScrollView. Use from a layout that renders a persistent
 * sticky header above its routes — the layout measures its own header and
 * passes that height through.
 */
export function ScreenTopInsetProvider({ topInset, children }: ProviderProps) {
  return (
    <ScreenTopInsetContext.Provider value={{ topInset }}>{children}</ScreenTopInsetContext.Provider>
  );
}
